/**
 * Textos de fuente de datos para KPIs de Informes (puro; testeable en Node sin RN).
 */
import type { ReportsOperacionKpiSources, ReportsOperacionSource } from '../domain/reportsTypes';

export type ReportsDataSourceFormatOptions = {
  /** Si el rango no es un solo día calendario, las franjas horarias no aplican y no deben figurar como dato local. */
  salesTimeBandsApplicable?: boolean;
};

export function formatReportsOperacionDataSources(
  kpi: ReportsOperacionKpiSources,
  salesList?: ReportsOperacionSource | null,
  options?: ReportsDataSourceFormatOptions
): string {
  const bandsMatter = options?.salesTimeBandsApplicable !== false;
  const kpiAllServer =
    kpi.cash === 'server' &&
    kpi.salesRange === 'server' &&
    kpi.comparison === 'server' &&
    kpi.cashSessions === 'server' &&
    (!bandsMatter || kpi.timeBands === 'server');

  const lines: string[] = [];

  if (kpiAllServer) {
    lines.push('Caja, ventas, comparación, franjas y aperturas de caja: servidor.');
  } else {
    const deviceParts: string[] = [];
    if (kpi.cash === 'device') deviceParts.push('caja');
    if (kpi.salesRange === 'device') deviceParts.push('ventas del período');
    if (kpi.comparison === 'device') deviceParts.push('comparación');
    if (kpi.cashSessions === 'device') deviceParts.push('aperturas de caja');
    if (bandsMatter && kpi.timeBands === 'device') deviceParts.push('franjas horarias');
    if (deviceParts.length > 0) {
      lines.push(`Sin red o error remoto. Datos locales: ${deviceParts.join(', ')}.`);
    }
  }

  if (salesList != null) {
    lines.push(
      salesList === 'server'
        ? 'Listado: servidor.'
        : 'Listado: solo lo de esta compu hasta sincronizar.'
    );
  } else {
    lines.push('Detalle por período: pestaña Ventas.');
  }

  return lines.join('\n');
}

export function formatReportsVentasDataSources(
  kpi: Pick<ReportsOperacionKpiSources, 'salesRange' | 'comparison' | 'timeBands'>,
  salesList: ReportsOperacionSource | null,
  options?: ReportsDataSourceFormatOptions
): string {
  const bandsMatter = options?.salesTimeBandsApplicable !== false;
  const allServer =
    kpi.salesRange === 'server' &&
    kpi.comparison === 'server' &&
    (!bandsMatter || kpi.timeBands === 'server');
  if (allServer && (salesList == null || salesList === 'server')) {
    return '';
  }
  const lines: string[] = [];
  if (!allServer) {
    const deviceParts: string[] = [];
    if (kpi.salesRange === 'device') deviceParts.push('ventas del período');
    if (kpi.comparison === 'device') deviceParts.push('comparación');
    if (bandsMatter && kpi.timeBands === 'device') deviceParts.push('franjas horarias');
    if (deviceParts.length > 0) {
      lines.push(`Sin red o error remoto. Local: ${deviceParts.join(', ')}.`);
    }
  }
  if (salesList === 'device') {
    lines.push('Listado de esta compu hasta sincronizar.');
  }
  return lines.join(' ');
}

export function formatReportsPersonalDataSources(salesByCashierSource: 'server' | 'device'): string {
  if (salesByCashierSource === 'server') return '';
  return 'Sin red o error remoto. Ranking por operador no disponible.';
}

export function isReportsAuthorizationError(message: string) {
  const lower = message.toLowerCase();
  return lower.includes('not authorized') || lower.includes('unauthorized') || lower.includes('forbidden');
}
